module.exports = __webpack_public_path__ + "static/KIN0-765d1cb932db4a2e33d8022a828e5c06.png";